import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';

import { LOCALE, TranslatePipe } from '@core/i18n-legacy';
import {
  ConnectedOverlayDirective,
  DotComponent,
  DropdownComponent,
  DropdownItemComponent,
  DropdownWidth,
  IconComponent,
  OverlayOriginDirective,
} from '@core/user-interface-legacy';

import { TellentAppShellTopbarButtonComponent } from '../tellent-app-shell-topbar-button/tellent-app-shell-topbar-button.component';

const CONTACT_SALES_URLS: Record<string, string> = {
  en: 'https://tellent.com/contact-us',
  de: 'https://tellent.com/de/kontakt',
  fr: 'https://tellent.com/fr/contact',
  nl: 'https://tellent.com/nl/contact',
};

const HELP_CENTER_URLS: Record<string, string> = {
  en: 'https://support.tellent.com',
  de: 'https://support.tellent.com/de/',
  fr: 'https://support.tellent.com/fr/',
  nl: 'https://support.tellent.com/nl/',
};

@Component({
  selector: 'tlc-help-dropdown',
  templateUrl: './help-dropdown.component.html',
  styleUrl: './help-dropdown.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    DotComponent,
    DropdownComponent,
    DropdownItemComponent,
    IconComponent,
    ConnectedOverlayDirective,
    OverlayOriginDirective,
    TranslatePipe,
    TellentAppShellTopbarButtonComponent,
  ],
})
export class HelpDropdownComponent {
  protected readonly DropdownWidth = DropdownWidth;

  readonly #locale = inject(LOCALE);

  public helpCenterUrl = input<string | undefined>(undefined);
  public productUpdatesUrl = input('https://updates.tellent.com');
  public shareFeedbackUrl = input('https://feedback.tellent.com');
  public showGetStarted = input(true);
  public showContactSupport = input(true);
  public showContactSales = input(true);
  public showCopyDebugInfo = input(false);
  public isActive = input(false);
  public isUnread = input(false);
  public isContactSupportUnread = input(false);

  public chatWithUs = output<void>();
  public getStarted = output<void>();
  public productUpdatesClick = output<void>();
  public copyDebugInfo = output<void>();

  protected hasAnyUnread = computed(() => this.isUnread() || this.isContactSupportUnread());

  protected resolvedHelpCenterUrl = computed(
    () => this.helpCenterUrl() ?? HELP_CENTER_URLS[this.#locale] ?? HELP_CENTER_URLS['en'],
  );

  protected resolvedContactSalesUrl = computed(
    () => CONTACT_SALES_URLS[this.#locale] ?? CONTACT_SALES_URLS['en'],
  );

  protected onProductUpdatesClick(dropdown: ConnectedOverlayDirective): void {
    dropdown.open = false;
    this.productUpdatesClick.emit();
  }

  protected onGetStarted(dropdown: ConnectedOverlayDirective): void {
    dropdown.open = false;
    this.getStarted.emit();
  }

  protected onChatWithUs(dropdown: ConnectedOverlayDirective): void {
    dropdown.open = false;
    this.chatWithUs.emit();
  }

  protected onCopyDebugInfo(dropdown: ConnectedOverlayDirective): void {
    dropdown.open = false;
    this.copyDebugInfo.emit();
  }
}
